import Tooltip from "rc-tooltip";
import React, { PropsWithChildren, useCallback, useEffect, useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import type { ButtonProps } from "semantic-ui-react";

type ToggleButtonProps = {
	onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, data: ButtonProps) => void;
	active?: boolean;
	label: string;
	icon: string;
};

const ToggleButton = ({ onClick, active, label, icon }: ToggleButtonProps) => {
	return (
		<Button icon compact onClick={onClick} toggle active={active}>
			<Icon className={icon} size="large" />
			<span>{label}</span>
		</Button>
	);
};

type ActionButtonProps = {
	onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, data: ButtonProps) => void;
	active?: boolean;
	label: string;
	icon: string;
};

const ActionButton = ({ onClick, label, icon }: ActionButtonProps) => {
	return (
		<Button icon compact onClick={onClick}>
			<Icon className={icon} size="large" />
			<span>{label}</span>
		</Button>
	);
};

export const ControlGroup = ({ children }: PropsWithChildren) => {
	const [open, setOpen] = useState(false);

	const closeGroup = useCallback(() => {
		setOpen(false);
	}, []);

	useEffect(() => {
		if (open) {
			window.addEventListener("click", closeGroup);
		} else {
			window.removeEventListener("click", closeGroup);
		}

		return () => {
			window.removeEventListener("click", closeGroup);
		};
	}, [closeGroup, open]);

	return (
		<div onClick={(e) => e.stopPropagation()}>
			<Tooltip
				placement="bottom"
				align={{ offset: [0, -2] }}
				mouseEnterDelay={0}
				mouseLeaveDelay={0}
				trigger="hover"
				overlay={
					<>
						<p>Tool Box</p>
					</>
				}
				motion={{ motionName: "rc-tooltip-zoom" }}
			>
				<Button
					className="controlGroup"
					style={{ height: 33, width: 33, padding: 0 }}
					circular
					icon
					onClick={(e) => {
						e.stopPropagation();
						setOpen((prev) => !prev);
					}}
				>
					<Icon className="tools" />
				</Button>
			</Tooltip>
			{open && (
				<div
					className="controlPanel"
					style={{ position: "absolute", top: 0, right: 50, overflow: "visible", maxHeight: 40 * 10 }}
				>
					<div className="scrollableContent" style={{ flexDirection: "column", display: "flex" }}>
						{children}
					</div>
				</div>
			)}
		</div>
	);
};

ControlGroup.Toggle = ToggleButton;
ControlGroup.Action = ActionButton;
